import React from 'react';
import { useTranslation } from 'react-i18next';

const PullToRefresh = ({ pullDistance, isRefreshing, refreshThreshold }) => {
  const { t } = useTranslation();
  
  if (!(pullDistance > 0 || isRefreshing)) {
    return null;
  }
  
  return (
    <div 
      className="pull-indicator" 
      style={{ height: Math.max(pullDistance, isRefreshing ? refreshThreshold : 0) }}
    >
      <div className={`refresh-spinner ${isRefreshing ? 'spinning' : ''}`}>
        {isRefreshing ? (
          <span className="spinner"></span>
        ) : (
          <span 
            className="arrow" 
            style={{ opacity: pullDistance > refreshThreshold ? 0.3 : 1 }}
          ></span>
        )}
      </div>
      <div className="refresh-text">
        {isRefreshing 
          ? t('wallet.refresh.refreshing')
          : pullDistance > refreshThreshold 
            ? t('wallet.refresh.releaseToRefresh')
            : t('wallet.refresh.pullToRefresh')
        }
      </div>
    </div>
  );
};

export default PullToRefresh;